import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/auth';
// const REST_API_BASE_URL = '/api';

export const userLogin = (user) => axiosInstance.post(REST_API_BASE_URL + "/login", user);
// export const userLogin = (user) => axiosInstance.post(REST_API_BASE_URL , user);

export const registerUser = (user) => axiosInstance.post(REST_API_BASE_URL + "/signup", user);
export const userList = () => axiosInstance.get(REST_API_BASE_URL);
export const userCount = () => axiosInstance.get(REST_API_BASE_URL + '/count');
export const getUserByUsername = (username) =>
    axiosInstance.get(`${REST_API_BASE_URL}/byUsername`, {
        params: { username: username }
        
    });

    export const changeUserPassword = (userId, data) =>
        axiosInstance.put(`/auth/${userId}`, data);
